module.exports = __webpack_public_path__ + "fonts/Vazir-Bold.5407a939.ttf";